<template>
  <div class="row page-wrapper d-flex" id="auth-wrapper">
    <div class="d-none d-md-block mb-0 col-md-5 col-12 translucent-bg">
      <div class="captions p-1">
        <div class="">
          <h1>
            {{ $t("scale") }} <br />
            {{ $t("scale-2") }}
          </h1>
          <p>{{ $t("real-time") }}</p>
        </div>
      </div>
    </div>
    <div class="col right-column mb-0 flex-column d-flex">
      <div class="logo-language">
        <img
          src="../../assets/images/logo.png"
          alt="logo"
          height="45"
          class="logo-img"
        />
        <div class="brand-logo ">
          <div
            style="position:relative"
            class=" mobile-lang "
            v-click-outside="hideDropMobile"
          >
            <div
              class="d-flex align-items-center cursor-pointer"
              style="column-gap:1rem; float:right"
              @click="show_drop_mobile = !show_drop_mobile"
            >
              <p class="mb-0 lang-text">
                {{ $t("change-lang") }}
              </p>
              <div class="d-flex align-items-center lang-keys">
                <span class="mr-2">{{ language }}</span>
                <IconDownArrow />
              </div>
            </div>
            <div
              class="dropdown-lang position-absolute p-10"
              v-if="show_drop_mobile"
            >
              <span
                class="d-flex justify-content-start align-items-center cursor-pointer hover-item"
                style="column-gap:0.7rem;"
                @click="switchLang(radioLang.locale, radioLang.lang)"
                v-for="radioLang in radios"
                :key="radioLang.locale"
              >
                <input
                  type="radio"
                  class="radio-btn"
                  :checked="language === radioLang.lang"
                />
                <span style="color: #5E6A79;">{{ radioLang.label }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="content">
        <slot name="content" />
      </div>

      <div class="powered-by">
        <p>{{ $t("powered-by") }}</p>
        <img src="../../assets/images/logo.png" alt="logo" height="45" />
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";
import IconDownArrow from "../../components/Iconsvg/IconDownArrow2.vue";

export default {
  name: "AuthWrapper",
  components: { IconDownArrow },
  data() {
    return {
      language: "EN",
      show_drop: false,
      show_drop_mobile: false,
      radios: [
        {
          label: "English - EN",
          lang: "EN",
          locale: "en",
        },
        {
          label: "French - FR",
          lang: "FR",
          locale: "fr",
        },
        {
          label: "Swahili - SW",
          lang: "SW",
          locale: "sw",
        },
      ],
      langKeys: {
        en: "EN",
        fr: "FR",
        sw: "SW",
      },
    };
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  methods: {
    switchLang: function(lang, val) {
      this.$i18n.locale = lang;
      this.language = val;
      this.$emit("new_language", lang);
    },
    hideDrop() {
      this.show_drop = false;
    },
    hideDropMobile() {
      this.show_drop_mobile = false;
    },
  },
  mounted() {
    let locale = this.$i18n.locale;
    this.language = this.langKeys[locale];
  },
};
</script>

<style scoped>
.page-wrapper {
  height: 100vh;
  background-color: #fefefe;
}

.translucent-bg {
  position: relative;
  background-image: linear-gradient(
      rgba(33, 63, 122, 0.8),
      rgba(33, 63, 122, 0.8)
    ),
    url("../../assets/images/Authbackgroungimage.png");
  background-size: cover;
  background-position: center;
}

.captions {
  display: flex;
  place-content: center;
  place-items: center;
  color: #ffffff;
  height: 100%;
}

.right-column {
  padding: 2rem 11rem;
  position: relative;
}

.logo-language {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.brand-logo img {
  height: 4rem;
}

h1 {
  /* line-height: 1.2; */
  font-size: 48px;
  line-height: 62.4px;
}

p {
  font-size: 24px;
}

.dropdown-lang {
  background: #ffffff;
  border: 0.3px solid rgba(99, 99, 99, 0.25);
  box-shadow: 0px 20px 50px rgba(29, 53, 71, 0.06);
  border-radius: 3px;
  z-index: 1000 !important;
  top: 2rem;
  color: #5e6a79;
  width: calc(100% - 1.5rem);
}
input[type="radio"] {
  border: 1px solid green !important;
}
input[type="radio"]:checked {
  background-color: red !important;
}
.radio-btn {
  border: 1px solid red !important;
}
.hover-item {
  padding: 8px;
}
.hover-item:hover {
  background-color: #f6f8f9;
}

.lang-text {
  font-weight: 500;
  font-size: 16px;
  color: #213f7a;
}

.lang-keys {
  font-weight: 600;
  font-size: 16px;
  color: #213f7a;
}

.powered-by {
  display: flex;
  column-gap: 10px;
  /* position: sticky;
  bottom: 10px;
  float: right;
  align-items: center; */
  /* right: 10%; */

  position: absolute;
  bottom: 10px;
  right: 5%;
}

.powered-by p {
  font-weight: 400;
  font-size: 12px;
  color: #5e6a79;
  margin-bottom: 0;
}

.powered-by img {
  height: 20px;
}

#auth-wrapper svg path {
  fill: #213f7a !important;
}

.content {
  display: flex;
  height: 100%;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  overflow-y: scroll;

  /* background: #ffffff;
  box-shadow: 0px 4px 10px rgba(138, 142, 148, 0.05);
  border-radius: 10px;
  padding: 0rem 1rem; */
}
.radio-btn {
  accent-color: #213f7a;
}

@media (max-width: 590px) {
  .right-column {
    padding: 3rem 2rem;
  }
  .logo-img {
    height: 38px;
  }
}

@media (max-width: 750px) and (min-width: 591px) {
  .right-column {
    padding: 3rem 6em;
  }
}

@media (max-width: 1250px) and (min-width: 820px) {
  .right-column {
    padding: 4rem 6rem 2rem;
  }
}

/* @media (max-width: 2100px) and (min-width: 1680px) {
  .right-column {
    padding: 2rem 6rem;
  } 
} */
</style>

<i18n>
    {
        "en": {
            "acc": "Don't have an account?",
            "change-lang": "Change Language",
            "email": "Email.",
            "fgt-pwd": "Forgot Password?",
            "login": "Log In",
            "password": "Password",
            "real-time": "With real-time data-backed decisions.",
            "scale": "Scale your Operation",
            "scale-2": "and increase profitability",
            "signup": "Sign Up",
            "welcome": "Welcome back! Please login to your account.",
            "zero-stress": "No stress, zero hassle.",
            "powered-by":"Powered by"
        },
        "es": {
            "acc": "¿No tienes una cuenta?",
            "change-lang": "Cambiar idioma",
            "email": "Correo electrónico.",
            "fgt-pwd": "¿Se te olvidó tu contraseña?",
            "login": "Iniciar sesión",
            "password": "Contraseña",
            "real-time": "Con decisiones respaldadas por datos en tiempo real.",
            "scale": "Escale su operación y",
            "scale-2": "aumentar la rentabilidad",
            "signup": "Regístrate",
            "welcome": "¡Bienvenido de nuevo! Por favor, ingrese a su cuenta.",
            "zero-stress": "Sin estrés, sin complicaciones.",
            "powered-by":""
        },
        "fr": {
            "acc": "Vous n'avez pas de compte?",
            "change-lang": "Changer de langue",
            "email": "E-mail.",
            "fgt-pwd": "Mot de passe oublié?",
            "login": "S'identifier",
            "password": "Mot de passe",
            "real-time": "Avec des décisions fondées sur des données en temps réel.",
            "scale": "Faites évoluer votre opération et",
            "scale-2": "et augmenter la rentabilité",
            "signup": "S'inscrire",
            "welcome": "Nous saluons le retour! Veuillez vous connecter à votre compte.",
            "zero-stress": "Pas de stress, zéro souci.",
            "powered-by":"Alimenté par"
        },
        "sw": {
		"acc": "Hauna akaunti?",
		"change-lang": "Badilisha Lugha",
		"email": "Barua pepe",
		"fgt-pwd": "Umesahau nywila?",
		"login": "Ingia",
		"password": "Nenosiri",
		"real-time": "Kwa maamuzi ya wakati halisi yanayoungwa mkono na data.",
		"scale": "Ongeza Uendeshaji wako na",
		"scale-2": "na kuongeza faida",
		"signup": "Jisajili",
		"welcome": "Karibu tena! Tafadhali ingia kwenye akaunti yako.",
		"zero-stress": "Hakuna dhiki, sifuri shida.",
        "powered-by":"Kinatumia"
	}
    }
    </i18n>
